export default {
    getTeacherPositionCategories: { method: 'get', url: 'teachers/positions/categories' },
    postTeacherPositionCategories: { method: 'post', url: 'teachers/positions/categories' },
    putTeacherPositionCategories: { method: 'put', url: 'teachers/positions/categories/{id}' },
    deleteTeacherPositionCategories: { method: 'delete', url: 'teachers/positions/categories/{id}' },
}
